export const GET_CURRENT_PAGE = 'GET_CURRENT_PAGE'
export const GET_CURRENT_ENV = 'GET_CURRENT_ENV'
